"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { siteConfig } from "@/lib/config";
import { UserMenu } from "./user-menu";

/**
 * Routes where the marketing nav is irrelevant — auth/onboarding
 * flows have their own brand mark in-page (e.g., the agent signup
 * landing has its own R + name in the left column) and the
 * Propiedades link is noise. We return null so these pages render
 * without the sticky chrome.
 */
const HIDDEN_PATHS = new Set(["/agente/registro"]);

/**
 * Sticky minimal header. The right-side `<UserMenu />` branches by
 * auth state: anonymous visitors see the "Crear cuenta" CTA (the
 * primary conversion path — routes through /registro to /cuenta),
 * authenticated visitors see an avatar + dropdown with logout (and,
 * for admins, a link into /monitoring).
 *
 * Backdrop-blurred + semi-transparent so content can show through on
 * scroll without making the header feel heavy.
 */
export function SiteHeader() {
  const pathname = usePathname();
  if (HIDDEN_PATHS.has(pathname)) return null;

  return (
    <header className="sticky top-0 z-40 border-b border-ink-200/60 bg-cream-50/85 backdrop-blur-md">
      <div className="container-wide flex h-14 items-center justify-between gap-4 sm:h-16">
        <div className="flex items-center gap-5 sm:gap-7">
          <Link
            href="/"
            aria-label={`Inicio · ${siteConfig.name}`}
            className="flex items-center gap-2.5 text-base font-extrabold text-ink hover:opacity-80"
          >
            <span
              aria-hidden
              className="flex h-8 w-8 items-center justify-center rounded-lg bg-coral text-base font-extrabold text-cream-50 sm:h-9 sm:w-9 sm:text-lg"
            >
              R
            </span>
            <span className="hidden sm:inline">Raíces RD</span>
          </Link>
          <Link
            href="/propiedades"
            className="text-sm font-medium text-ink-700 hover:text-coral"
          >
            Propiedades
          </Link>
        </div>
        <UserMenu />
      </div>
    </header>
  );
}
